import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Navbar from "../navbar/Navbar";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Button from "@material-ui/core/Button";
import Footer from "../footer/footer";
import { Link } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  }
}));

export default function ControlledExpansionPanels() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Navbar />
      <Link to="/Notes" id="back">
        <Button
          style={{ margin: "10px", marginTop: "70px" }}
          variant="contained"
          color="primary"
          href="#contained-buttons"
        >
          <KeyboardBackspaceIcon />
        </Button>
      </Link>
      <h1 id='desc' style={{ textAlign: "center" }}>Fourth sem CSE/ISE Notes</h1>

      <ExpansionPanel
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        style={{ marginTop: "40px" }}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>Mathematics 4</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a
    
                href="https://drive.google.com/file/d/1VHm8bMYDFc3LVn62UGDuXX5QAFvKFm4r/view?usp=sharing"
              >
                Module 1
              </a>
              <br />
              <a
  
                href="https://drive.google.com/file/d/1qBd6ARJinevupgHTAAlQAo7mx0CChNM9/view?usp=sharing"
              >
                Module 2
              </a>
              <br />
              <a
               
                href="https://drive.google.com/file/d/1pS5-Hv_HA_swqMRwVbiceqFE4HgKdwcy/view?usp=sharing"
              >
                Module 3
              </a>
              <br />
              <a
           
                href="https://drive.google.com/file/d/1cWmGCMefs-hzJWjZjLnIvUfQWf-R2Klr/view?usp=sharing"
              >
                Module 4
              </a>
              <br />
              <a
            
                href="https://drive.google.com/file/d/1npQhVvROGD4zKaenzHwbfzzpXv0sOQAz/view?usp=sharing"
              >
                Module 5
              </a>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: '30px' }}>
            <div style={{ color: "black" }}>
              <iframe style={{ width: '120px', height: '240px' }} marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=8193328493&asins=8193328493&linkId=616c4d869a9cebf2f45c16de0663b559&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className={classes.heading}>
            Software Engineering
          </Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
           Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a 
               href = "https://drive.google.com/file/d/1HwC9vxVlQcd3c9LZMUKqUmpq5mrVFzyt/view?usp=sharing">
                Module 1
              </a>
              <br />
              <a 
              href ="https://drive.google.com/file/d/1folPKPCbsbKV8foVZ3x8KnJJNm9wpx-e/view?usp=sharing">
                Module 2
              </a>
              <br />
              <a 
              href="https://drive.google.com/file/d/1n5Z38NjTZQ8ApIFALZ7QzAa9egJxRLo1/view?usp=sharing">
                Module 3
              </a>
              <br />
              <a 
               href ="https://drive.google.com/file/d/1WySWhDeGs4d-8TaJk-s-rQ9tMlYm1-_9/view?usp=sharing">
                Module 4
              </a>
              <br />
              <a 
               href="https://drive.google.com/file/d/1Qs2aVhS_0_wPIZx9fRta1s4rDutlVVti/view?usp=sharing">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: '30px' }}>
            <div style={{ color: "black" }}>
              <iframe style={{ width: '120px', height: '240px' }} marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=tf_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=B075CPJCWH&asins=B075CPJCWH&linkId=62a508afae98554391f452afa6ef8123&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
            </div>
          </Typography>

        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className={classes.heading}>DAA</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
           Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a 
              href ="https://drive.google.com/file/d/1dP2iICDhfq7hLTfxMC5tt9CFkmx_aOh5/view?usp=sharing">
                Module 1
              </a>
              <br />
              <a 
               href ="https://drive.google.com/file/d/1u_ql9-ZmRZ11srTmR5v-8hcHKXs5UsKL/view?usp=sharing">
                Module 2
              </a>
              <br />
              <a 
               href ="https://drive.google.com/file/d/1w1CUBrovlDnmw-_dU3LYmblHORegRfdu/view?usp=sharing">
                Module 3
              </a>
              <br />
              <a 
              href ="https://drive.google.com/file/d/1lCI9GQiiQA2Iw7hs6HGB7F5IFfJ_HM7Y/view?usp=sharing">
                Module 4
              </a>
              <br/>
              <a
              href ="https://drive.google.com/file/d/1nWyz6udk2HM65HeMwusEBWueTCnsrQbV/view?usp=sharing">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: '30px' }}>
            <div style={{ color: "black" }}>

              <iframe style={{ width: '120px', height: '240px' }} marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=B007YTJLIC&asins=B007YTJLIC&linkId=ad7dd825c17e3422b98ae638ec57e537&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>Micro Processor</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Not Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a style={{ color: "black" }} target="_blank">
                Module 1
              </a>
              <br />
              <a style={{ color: "black" }} target="_blank">
                Module 2
              </a>
              <br />
              <a style={{ color: "black" }} target="_blank">
                Module 3
              </a>
              <br />
              <a style={{ color: "black" }} target="_blank">
                Module 4
              </a>
              <br />
              <a style={{ color: "black" }} target="_blank">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: '30px' }}>
            <div style={{ color: "black" }}>


              <iframe style={{ width: '120px', height: '240px' }} marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=9332584044&asins=9332584044&linkId=5776e9bc1a51d5eac8b7a72dc6ecaacd&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
            </div>
          </Typography>
          <Typography style={{ marginLeft: '30px' }}>
            <div style={{ color: "black" }}>



              <iframe style={{ width: '120px', height: '240px' }} marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=B07465TQ7B&asins=B07465TQ7B&linkId=f2b85320bf06b66c3564f10b19a577fc&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>OOPS</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
          Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a 
              href ="https://drive.google.com/file/d/1odUsZmAvjPor9jb9HnFJeimibndJFtd5/view?usp=sharing">
                Module 1
              </a>
              <br />
              <a 
              href ="https://drive.google.com/file/d/1IqvNockIkJ4pg52FuKF-7aKJNFNXeCl3/view?usp=sharing">
                Module 2
              </a>
              <br />
              <a 
              href ="https://drive.google.com/file/d/1IqvNockIkJ4pg52FuKF-7aKJNFNXeCl3/view?usp=sharing">
                Module 3
              </a>
              <br />
              <a 
               href ="https://drive.google.com/file/d/1yKSZxG5kHhZoD1jTQece8e42cgZzcajU/view?usp=sharing">
                Module 4
              </a>
              <br />
              <a 
               href ="https://drive.google.com/file/d/1Z0fdiEnmaC1qKrZ3RmtFXxRaLj2kTN5o/view?usp=sharing">
                Module 5
              </a>
              <br />
            </div>
          </Typography>

          <Typography style={{ marginLeft: '30px' }}>
            <div style={{ color: "black" }}>


              <iframe style={{ width: '120px', height: '240px' }} marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=B078JRSY7L&asins=B078JRSY7L&linkId=0c9a6b2620ed230a48abecdbf0ad4372&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
            </div>
          </Typography>
          <Typography style={{ marginLeft: '30px' }}>
            <div style={{ color: "black" }}>

              <iframe style={{ width: '120px', height: '240px' }} marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=0198065302&asins=0198065302&linkId=4a8d9f062af4595c4b31e7811d0abda9&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>
            Data Communication
          </Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
           Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a 
              href ="https://drive.google.com/file/d/1zhMPXyq579IhpGPdb0bIbg6RPYcpU8B3/view?usp=sharing">
                Module 1
              </a>
              <br />
              <a 
              href ="https://drive.google.com/file/d/1i7sRYBsL91Lp3eVj4KTmRXRp1_NL30wR/view?usp=sharing">
                Module 2
              </a>
              <br />
              <a 
              href ="https://drive.google.com/file/d/1uJTTJt34W6eljTTYRykoobhqJnOCawxa/view?usp=sharing">
                Module 3
              </a>
              <br />
              <a 
              href ="https://drive.google.com/file/d/19hPNPRjCO4xAMhFYSfC4FJzActvupTrD/view?usp=sharing">
                Module 4
              </a>
              <br />
              <a 
               href ="https://drive.google.com/file/d/14aRbeuDpJkuSNWAhSNzCXszI6SGTGeQH/view?usp=sharing">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: '30px' }}>
            <div style={{ color: "black" }}>

              <iframe style={{ width: '120px', height: '240px' }} marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=1259064751&asins=1259064751&linkId=f973208b4230580116a6dc4f9efe94b2&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>


      <Footer />
    </div>
  );
}
